<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="950"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="info"
        fab
        title="Mass Edit"
        v-on="on"
      >
        <v-icon medium>
          mdi-checkbox-multiple-blank-outline
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Fund Bucket Item
            </h4>
            <p class="category font-weight-thin">
              Mass Edit Fund Bucket Item
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-container>
        <template>
          <v-form
            v-if="show && !loading"
            ref="upper"
            lazy-validation
          >
            <v-combobox
              v-model="record.schemas"
              label="Schema"
              multiple
              required 
              :rules="requiredRules"
              :items="schemas"
              item-text="schema_name" 
              item-value="schema_name"
              :return-object="false"
            />
            <v-combobox
              v-model="record.bucket"
              label="Bucket Name"
              multiple
              required 
              :rules="requiredRules"
              :items="filteredBucket" 
              item-text="fund_bucket.name"
              item-value="fund_bucket.id"
            />
            <v-combobox  
              v-model="record.company"
              label="Company"                
              multiple
              :items="companies"
              item-text="name"
              item-value="id"
            />
            <v-combobox
              v-model="record.priority"
              label="Priority"
              :items="priorities"
            />
            <v-combobox
              v-model="record.description"
              label="Bucket Description"
              :items="descriptions"
              item-text="description"
              item-value="id"
            />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="getFundBucketIds"
              >
                Go
              </v-btn>
            </v-card-actions>
          </v-form>

          <v-form
            v-if="!show"
            ref="form"
            lazy-validation
            class="box-border pa-3 mt-3"
          >
            <v-row
              justify="center"
              align="center"
            >
              <v-col
                cols="5"
                class="pl-6 pr-6"
              >
                <v-container class="box-border">
                  <h3>Differences:</h3>
                  <v-row>
                    <v-col cols="6">
                      Company Name :
                    </v-col>
                    <v-hover v-slot:default="{ hover }">
                      <v-col cols="6">
                        {{ CompanyNameCounter }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            <p
                              style="margin:0px"
                              v-html="CompanyText"
                            />
                          </div>
                        </v-expand-transition>
                      </v-col>
                    </v-hover>
                  </v-row>
                  <v-row>
                    <v-col>Bucket Name :</v-col>
                    <v-hover v-slot:default="{ hover }">
                      <v-col cols="6">
                        {{ bucketNameCounter }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            <p
                              style="margin:0px"
                              v-html="bucketText"
                            />
                          </div>
                        </v-expand-transition>
                      </v-col>
                    </v-hover>
                  </v-row>
                  <v-row>
                    <v-col>Bucket Description :</v-col>
                    <v-hover v-slot:default="{ hover }">
                      <v-col cols="6">
                        {{ bucketDescriptionCounter }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            <p
                              style="margin:0px"
                              v-html="bucketDescriptionText"
                            />
                          </div>
                        </v-expand-transition>
                      </v-col>
                    </v-hover>
                  </v-row>
                  <v-row>
                    <v-col>Min. Amount :</v-col>
                    <v-hover v-slot:default="{ hover }">
                      <v-col cols="6">
                        {{ minCounter }} 
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            <p
                              style="margin:0px"
                              v-html="minText"
                            />
                          </div>
                        </v-expand-transition>
                      </v-col>
                    </v-hover>
                  </v-row>
                  <v-row>
                    <v-col>Max. Amount :</v-col>
                    <v-hover v-slot:default="{ hover }">
                      <v-col cols="6">
                        {{ maxCounter }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            <p
                              style="margin:0px"
                              v-html="maxText"
                            />
                          </div>
                        </v-expand-transition>
                      </v-col>
                    </v-hover>
                  </v-row>
                  <v-row>
                    <v-col>Interval :</v-col>
                    <v-hover v-slot:default="{ hover }">
                      <v-col cols="6">
                        {{ intervalCounter }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            <p
                              style="margin:0px"
                              v-html="intervalText"
                            />
                          </div>
                        </v-expand-transition>
                      </v-col>
                    </v-hover>
                  </v-row>
                  <v-row>
                    <v-col>Priority :</v-col>
                    <v-hover v-slot:default="{ hover }">
                      <v-col cols="6">
                        {{ priorityCounter }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            <p
                              style="margin:0px"
                              v-html="priorityText"
                            />
                          </div>
                        </v-expand-transition>
                      </v-col>
                    </v-hover>
                  </v-row>
                  <v-row>
                    <v-col>Has Quota :</v-col>
                    <v-hover v-slot:default="{ hover }">
                      <v-col cols="6">
                        {{ hasQuotaCounter }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            <p
                              style="margin:0px"
                              v-html="hasQuotaText"
                            />
                          </div>
                        </v-expand-transition>
                      </v-col>
                    </v-hover>
                  </v-row>
                  <v-divider />
                  <v-row>
                    <v-col>Total rows affected :</v-col>
                    <v-col>{{ affectedRowCounter }}</v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="2">
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-icon large>
                    mdi-arrow-right-bold
                  </v-icon>
                </v-row>
              </v-col>
              <v-col
                cols="5"
                class="pl-6 pr-6"
                style="height:487px"
              >
                <v-container
                  class="box-border"
                  style="height:463px"
                >
                  <v-combobox
                    label="Schema"
                    :value="newRecord.schema"
                    disabled
                    required
                  />
                  <v-combobox
                    label="Bucket Name"
                    :value="newRecord.bucket"
                    disabled
                    required
                  />

                  <v-combobox
                    v-model="newRecord.company"
                    label="Company"
                    required
                    item-text="name"
                    item-value="id"
                    :items="companies"
                    :rules="requiredRules"
                  />
                  <v-combobox
                    v-model="newRecord.bucket_description"
                    label="Bucket Description"
                    required
                    item-text="description"
                    item-value="id"
                    :items="descriptions"
                    :rules="requiredRules"
                  />
                  <v-row>
                    <v-col
                      cols="4"
                      class="input-row"
                    >
                      <v-text-field
                        v-model="newRecord.min"
                        label="Min"
                        required
                        :rules="[minLogic]"
                        @input="$set(newRecord,newRecord.min,parseFloat($event))"
                      />
                    </v-col>
                    <v-col
                      cols="4"
                      class="input-row"
                    >
                      <v-text-field
                        v-model="newRecord.interval"
                        label="Interval"
                        required
                        :rules="[intervalLogic]"
                        @input="$set(newRecord,newRecord.interval,parseFloat($event))"
                      />
                    </v-col>
                    <v-col
                      cols="4"
                      class="input-row"
                    >
                      <v-text-field
                        v-model="newRecord.max"
                        label="Max"
                        required
                        :rules="[maxLogic]"
                        @input="$set(newRecord,newRecord.max,parseFloat($event))"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="4"
                      class="input-row"
                    >
                      <p
                        class="mt-5"
                        style="text-align:right"
                      >
                        Has Quota?    
                      </p>
                    </v-col>
                    <v-col
                      cols="4"
                      class="input-row"
                    >
                      <v-switch
                        v-model="newRecord.hasquota"
                        color="success"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
            >
              <v-btn
                color="primary"
                class="mr-4"
                @click="back"
              >
                Back
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                @click="update"
              >
                Edit
              </v-btn>
            </v-row>
          </v-form>

          <v-snackbar
            v-model="snack"
            bottom
            :color="snackColor"
            class="center-snackbar"
          >
            {{ snackText }}
          </v-snackbar>
        </template>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      show: true,
      snackColor: '',
      snack: '',
      snackText: '',

      CompanyNameCounter: 0,
      bucketNameCounter: 0,    
      bucketDescriptionCounter: 0,            
      minCounter: 0,
      maxCounter: 0,
      intervalCounter: 0,
      priorityCounter: 0,
      hasQuotaCounter: 0,
      affectedRowCounter: 0,

      CompanyText: '',
      bucketText: '',
      bucketDescriptionText: '',
      minText: '',
      maxText: '',
      intervalText: '',
      priorityText: '',
      hasQuotaText: '',

      requiredRules: [
        v => !!v || '*This field is required',
      ],

      minRules: [
        v => !!v || '*This field is required',
        v => (!!v && !isNaN(v)) || 'Only number is allowed',
        v => ((!!v && !isNaN(v)) && /^\d+(\.\d{1,2})?$/.test(v)) || '*Only 2 Decimal is allowed',
      ],
      maxRules: [
        v => !!v || '*This field is required',
        v => (!!v && !isNaN(v)) || 'Only number is allowed',
        v => ((!!v && !isNaN(v)) && /^\d+(\.\d{1,2})?$/.test(v)) || '*Only 2 Decimal is allowed',
      ],
      intervalRules: [
        v => !!v || '*This field is required',
        v => (!!v && !isNaN(v)) || 'Only number is allowed',
      ],

      record: {
        schemas: '',
        company: '',
        bucket: '',
        description: '',
        priority: '',
      },

      newRecord: {
        company: '',
        bucket_description: '',
        min: '',
        max: '',
        interval: '',
        hasquota: '',
        schema: [],
        bucket: [],
        ids: [],
      },

      schemas: [],
      companies: [],
      fundBucketHasTypes: [],
      priorities: [],
      descriptions: [],
    }),
    computed: {
      filteredBucket () {
        if (this.record.schemas.length === 0) return
        
        return this.fundBucketHasTypes.filter(fundBucketHasType => {
          const schema = fundBucketHasType.schema_name

          return _.union([schema], this.record.schemas).length === this.record.schemas.length
        })
      },
    },
    watch: {
      newRecord: 'validate',
      dialog (value) {
        if (value) {
          this.loadData()
          this.$refs.form.resetValidation()
        } else {
          this.$resetData()
        }
      },
    },

    methods: {
      loadData () {
        this.loading = true
        Promise.all([
          this.$api.companies().withSchema(),
          this.$api.companies().list(),
          this.$api.fundBucketItems().list(),
          this.$api.fundBucketItemDescriptions().list(),
          this.$api.fundBucketHasTypes().list(),
        ])
          .then(([schemas, companies, fundBucketItems, bucketDescriptions, fundBucketHasTypes]) => {
            this.schemas = schemas.data
            this.companies = companies.data
            this.fundBucketHasTypes = fundBucketHasTypes.data
            fundBucketItems.data.map(item => {
              this.priorities.push(item.priority)
              this.priorities.sort(function (a, b) { return a - b })
            })
            this.descriptions = bucketDescriptions.data
            this.loading = false
          })
      },
      validate () {
        if (this.show) {
          this.$refs.upper.validate()
        } else {
          this.$refs.upper.validate()
          this.$refs.form.validate()
        }       
      },
      back () {
        this.show = true
      },
      closeDialog () {
        this.dialog = false
        this.show = true

        if (this.show) {
          this.$refs.upper.resetValidation()
        } else {
          this.$refs.upper.resetValidation()
          this.$refs.form.resetValidation()
        }
      },
      getFundBucketIds () {
        if (this.$refs.upper.validate()) {
          const companyIds = []
          const bucketIds = []

          const selectedSchemaName = []
          const selectedBucketName = []

          this.record.schemas.map(item => {
            selectedSchemaName.push(item)
          })
          if (this.record.company) {
            this.record.company.map(item => {
              companyIds.push(item.id)
            })
          }
          this.record.bucket.map(item => {
            selectedBucketName.push(item.fund_bucket.name)
            bucketIds.push(item.fund_bucket.id)
          })
          this.$api.fundBucketItems().ids(this.getIdForm(companyIds, bucketIds))
            .then(response => {
              let x = []
              x = [].concat(...response.data) // flatten array

              if (x.length) {
                const companyName = []
                const bucketName = []
                const bucketDescription = []
                const min = []
                const max = []
                const multipleOf = []
                const priority = []
                const hasQuota = []

                x.map(item => {
                  this.newRecord.ids.push(item.id)

                  if (!this.CompanyText.includes(item.company.name)) {
                    this.CompanyText += item.company.name + '<br>'
                  }
                  companyName.push(item.company.name)

                  if (!this.bucketText.includes(item.fund_bucket.name)) {
                    this.bucketText += item.fund_bucket.name + '<br>'
                  }
                  bucketName.push(item.fund_bucket.name)

                  if (!this.bucketDescriptionText.includes(item.fund_bucket_item_descriptions.description)) {
                    this.bucketDescriptionText += item.fund_bucket_item_descriptions.description + '<br>'
                  }
                  bucketDescription.push(item.fund_bucket_item_descriptions.description)

                  if (!this.minText.includes(item.min)) {
                    this.minText += item.min + '<br>'
                  }
                  min.push(item.min)

                  if (!this.maxText.includes(item.max)) {
                    this.maxText += item.max + '<br>'
                  }
                  max.push(item.max)

                  if (!this.intervalText.includes(item.multiple_of)) {
                    this.intervalText += item.multiple_of + '<br>'
                  }
                  multipleOf.push(item.multiple_of)

                  if (!this.priorityText.includes(item.priority)) {
                    this.priorityText += item.priority + '<br>'
                  }
                  priority.push(item.priority)

                  if (!this.hasQuotaText.includes(item.has_quota)) {
                    this.hasQuotaText += item.has_quota + '<br>'
                  }
                  hasQuota.push(item.has_quota)
                })

                this.hasQuotaCounter = [...new Set(hasQuota)].length
                this.priorityCounter = [...new Set(priority)].length
                this.CompanyNameCounter = [...new Set(companyName)].length
                this.bucketNameCounter = [...new Set(bucketName)].length
                this.bucketDescriptionCounter = [...new Set(bucketDescription)].length
                this.minCounter = [...new Set(min)].length
                this.maxCounter = [...new Set(max)].length
                this.intervalCounter = [...new Set(multipleOf)].length

                this.newRecord.schema = selectedSchemaName
                this.newRecord.bucket = selectedBucketName

                this.affectedRowCounter = x.length
                this.show = false  
              } else {
                this.$snack({
                  color: 'error',
                  message: 'No record found',
                })
              }
            })
        }
      },
      getIdForm (companyIds, bucketIds) {
        return {
          company_ids: companyIds,
          bucket_ids: bucketIds,
          description_id: this.record.description.id,
          priority: this.record.priority,
        }
      },
      update () {
        if (this.$refs.form.validate()) {         
          this.$api.fundBucketItems().updateMany(this.updateForm())
            .then(response => {
              this.$emit('updated')
              this.$snack({
                color: 'success',
                message: response.data.message,
              })
              this.dialog = false
            })
        }
      },
      updateForm () {
        return {
          record_ids: this.newRecord.ids,
          company_id: this.newRecord.company.id,
          bucket_description_id: this.newRecord.bucket_description.id,
          min: this.newRecord.min,
          max: this.newRecord.max,
          interval: this.newRecord.interval,
          has_quota: this.newRecord.hasquota ? '1' : '0',
        }
      },
      maxLogic () {
        if (this.newRecord.max !== '') {
          if (!isNaN(this.newRecord.max)) {
            if (/^\d+(\.\d{1,2})?$/.test(this.newRecord.max)) {
              if (parseFloat(this.newRecord.max) <= parseFloat(this.newRecord.min)) {
                return 'Max cannot less than or equal to Min'
              }

              if (this.newRecord.min !== '' && this.newRecord.interval !== '') {
                const min = parseFloat(this.newRecord.min)
                const interval = parseFloat(this.newRecord.interval)
                const max = parseFloat(this.newRecord.max)
                let n = 0

                if (parseFloat(this.newRecord.interval) > parseFloat(this.newRecord.max)) {
                  n = Math.ceil((max - min) / interval)
                } else {
                  n = Math.floor((max - min) / interval)
                }

                let actualMax = ((n * interval) + min)

                while (!(/^\d+(\.\d{1,2})?$/.test(actualMax)) && n > 0) {
                  const a = ((n * interval) + min)
                  actualMax = a
                  n--
                }

                if (((((parseFloat(this.newRecord.max) - parseFloat(this.newRecord.min)) * 100) % (parseFloat(this.newRecord.interval) * 100))) / 100 !== 0) {
                  return 'Do you mean ' + actualMax + '?'
                }
              }
            } else {
              return '*Only 2 Decimal is allowed'
            }
          } else {
            return 'Only number is allowed'
          }
        } else {
          return '*This field is required'
        }

        return true
      },

      minLogic () {
        if (this.newRecord.min !== '') {
          if (!isNaN(this.newRecord.min)) {
            if (/^\d+(\.\d{1,2})?$/.test(this.newRecord.min)) {
              if (parseFloat(this.newRecord.min) >= parseFloat(this.newRecord.max)) {
                return 'Min cannot greater than or equal to Max'
              }
                        
              if (this.newRecord.interval !== '' && this.newRecord.max !== '') {
                const min = parseFloat(this.newRecord.min)
                const interval = parseFloat(this.newRecord.interval)
                const max = parseFloat(this.newRecord.max)

                let n = Math.floor((max - min) / interval)

                let actualMin = (max - (n * interval))

                while (!(/^\d+(\.\d{1,2})?$/.test(actualMin)) && n > 0) {
                  const a = (max - (n * interval))
                  actualMin = a
                  n--
                }

                if (((((parseFloat(this.newRecord.max) - parseFloat(this.newRecord.min)) * 100) % (parseFloat(this.newRecord.interval) * 100)) / 100) !== 0) {
                  return 'Do you mean ' + actualMin + '?' 
                }
              }
            } else {
              return '*Only 2 Decimal is allowed'
            }
          } else {
            return 'Only number is allowed'
          }
        } else {
          return '*This field is required'
        }
        return true
      },

      intervalLogic () {
        if (this.newRecord.interval !== '') {
          if (!isNaN(this.newRecord.interval)) {
            if (/^\d+(\.\d{1,2})?$/.test(this.newRecord.interval)) {
              if (parseFloat(this.newRecord.interval) > parseFloat(this.newRecord.max)) {
                return 'Interval cannot greater than Max'
              }

              if (this.newRecord.min !== '' && this.newRecord.max !== '') {
                const min = parseFloat(this.newRecord.min)
                const interval = parseFloat(this.newRecord.interval)
                const max = parseFloat(this.newRecord.max)

                let n = Math.floor((max - min) / interval)

                let actualInterval = ((max - min) / n)

                while (!(/^\d+(\.\d{1,2})?$/.test(actualInterval)) && n > 0) {
                  const a = ((max - min) / n)
                  actualInterval = a
                  n--
                }

                if (((((parseFloat(this.newRecord.max) - parseFloat(this.newRecord.min)) * 100) % (parseFloat(this.newRecord.interval) * 100)) / 100) !== 0) {
                  return 'Do you mean ' + actualInterval + '?'
                }
              }
            } else {
              return '*Only 2 Decimal is allowed'
            }
          } else {
            return 'Only number is allowed'
          }
        } else {
          return '*This field is required'
        }

        return true
      },
    },
  }
</script>

<style scoped>
    .input-row{
        padding-top:0px;
        padding-bottom:0px
    }

    .box-border{
        border-radius: 5px;
        border:1px solid #c5c5c5c5
    }

    .center-snackbar .v-snack__wrapper .v-snack__content{
        margin:auto !important;
        width:unset !important;
    }
</style>
